import { render, staticRenderFns } from "./companyBeenReg.vue?vue&type=template&id=39d32d4e&scoped=true&"
import script from "./companyBeenReg.vue?vue&type=script&lang=js&"
export * from "./companyBeenReg.vue?vue&type=script&lang=js&"
import style0 from "./companyBeenReg.vue?vue&type=style&index=0&id=39d32d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d32d4e",
  null
  
)

export default component.exports